<p>document-type-selection works!</p>
